import { api } from './configs/axiosConfig';

const endPoint = "/attendance";

export const attendanceAPI = {
    getAttendanceDetails: async function (fromDate, toDate, pcode, empCode = null, showAll = false, page = 1, pageSize = 20) {
        const response = await api.request({
            url: endPoint,
            method: 'GET',
            params: { fromDate, toDate, pcode, empCode, showAll, page, pageSize }
        });

        return response.data;
    },
    getEmployees: async function (pcode) {
        const response = await api.request({
            url: `${endPoint}/employees`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    },
    checkAdminAccess: async function (pcode) {
        const response = await api.request({
            url: `${endPoint}/checkadmin`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    }
};
